import React from 'react';
import { motion, type Variants } from 'framer-motion';
import { fadeInUp, viewportOnce } from './motion';

type RevealProps = {
  children: React.ReactNode;
  variants?: Variants;
  delay?: number;
  style?: React.CSSProperties;
  className?: string;
};

const Reveal: React.FC<RevealProps> = ({ children, variants = fadeInUp, delay = 0, style, className }) => (
  <motion.div
    initial="hidden"
    whileInView="visible"
    viewport={viewportOnce}
    variants={variants}
    transition={{ delay }}
    style={style}
    className={className}
  >
    {children}
  </motion.div>
);

export default Reveal;
